import { ref, reactive, computed, watch } from "vue";
import { defineStore } from "pinia";
// import { useRequestsStore } from '@/stores/storeRequests';

export const useFieldsStore = defineStore("fields", () => {
	// const storeRequests = useRequestsStore()

	const fields = ref({
		firstName: {
			title: "",
			disabledBtn: false,
		},
		lastName: {
			title: "",
			disabledBtn: false,
		},
		email: {
			title: "",
			disabledBtn: false,
		},
		phone: {
			title: "",
			disabledBtn: false,
		},
		birthday: {
			title: "",
			disabledBtn: false,
		},
		rules: {
			title: false,
			disabledBtn: false,
		},
		agreement: {
			title: false,
			disabledBtn: false,
		},
		confirmationCode: {
			title: "",
			disabledBtn: false,
		},
		message: {
			title: "",
			disabledBtn: false,
		},
		files: [],
		filesForPost: [],
	});

	const isFeedbackBtn = computed(() => !fields.value.phone.disabledBtn || !fields.value.agreement.disabledBtn);
	const isSmsCodeBtn = computed(() => !fields.value.confirmationCode.disabledBtn);
	const isRegestrationBtn = computed(() => !fields.value.firstName.disabledBtn || !fields.value.email.disabledBtn);
	const isAuthorizationBtn = computed(() => !fields.value.phone.disabledBtn || !fields.value.password.disabledBtn);
	const isCahngePasswordBtn = computed(() => !fields.value.passwordRepeat.disabledBtn || !fields.value.password.disabledBtn);
	const isRecoveryPasswordBtn = computed(() => !fields.value.email.disabledBtn);

	

	const updateFields = (fieldName, fieldKey, value) => {
		if (fields.value[fieldName]) {
			fields.value[fieldName][fieldKey] = value;
		} else {
			console.log("updateFields:", fields.value[fieldName], value);
		}
	};

	const updateFiles = () => {
		fields.value.files = [];
		fields.value.filesForPost = [];
	};

	const updateRegestrationBtn = () => {
		fields.value.firstName.disabledBtn = false;
		fields.value.lastName.disabledBtn = false;
		fields.value.phone.disabledBtn = false;
		fields.value.email.disabledBtn = false;
		fields.value.agreement.disabledBtn = false;
		fields.value.rules.disabledBtn = false;
	};
	const updateFormContactFeedback = () => {
		fields.value.phone.disabledBtn = false;
		fields.value.agreement.disabledBtn = false;
		fields.value.phone.title = "";
		fields.value.agreement.title = false;
	};
	const updateAuthorization = () => {
		fields.value.phone.disabledBtn = false;
		fields.value.agreement.disabledBtn = false;
	};

	const isBtnDisabled = (keys = []) => {
		return keys.some((key) => !fields.value[key]?.disabledBtn);
	};

	// const resetFields = (payload = {}) => {
	// 	Object.entries(payload).forEach(([key, props]) => {
	// 		const target = fields.value[key];
	// 		if (!target) {
	// 			console.warn(`[resetFields] field "${key}" not found`);
	// 			return;
	// 		}
			
	// 		Object.entries(props || {}).forEach(([propKey, propVal]) => {
	// 			if (propVal === undefined) return; 
	// 			target[propKey] = propVal;
	// 		});
	// 	});
	// };

	// использование
	// resetFields({
	//     phone: { disabledBtn: false, title: '' },
	//     agreement: { disabledBtn: false }
	// })

	return {
		updateFields,
		updateFiles,
		updateRegestrationBtn,
		updateFormContactFeedback,
		updateAuthorization,
		// isDisbledBtn,
		isBtnDisabled,
		// resetFields,

		fields,
		isFeedbackBtn,
		isRegestrationBtn,
		isAuthorizationBtn,
		isRecoveryPasswordBtn,
		isCahngePasswordBtn,
		isSmsCodeBtn,
	};
});
